import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { AUDIT_SUMMARY } from 'graphql/audit.gql';
import { message } from 'antd';

export const useAuditSummaryData = (startDate?: string, endDate?: string) => {
  const { data, loading, error, refetch } = useQuery(AUDIT_SUMMARY, {
    variables: { startDate, endDate },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (error) message.error(error.message || 'Failed to fetch audit summary');
  }, [error]);

  return {
    data: data?.auditSummary ?? [],
    loading,
    error,
    refetch,
  };
};
